import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

export interface ISuccessBox {
  text: string;
  children?: React.ReactNode;
}

const SuccessBox = ({ text, children }: ISuccessBox) => {
  return (
    <div className='max-w-lg flex flex-col justify-center items-center gap-[16px]'>
      <CheckCircleIcon aria-hidden='true' className='h-[100px] w-[100px] text-content-primary' />
      <div className='bold text-grey800 font-[DKLiquidEmbrace] text-3xl text-center'>{text}</div>
      {children}
    </div>
  );
};

export default SuccessBox;
